<template>
  <div 
    :class="['mouse-pointer', pointerStyle]" 
    id="mouse-pointer"
    ref="MousePointerComp"
  >
    <div class="icon">
      <i class="icon-06"></i>
      <i class="icon-05"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MousePointerComp',
  data() {
    return {
      pointerStyle: ''
    }
  },
  mounted() {
    this.initMousePointerComp()
  },
  beforeUnmount() {
    this.cleanup()
  },
  methods: {
    initMousePointerComp() {
      // Mouse move handler
      const handleMouseMove = (event) => {
        const mouseX = event.clientX + 'px'
        const mouseY = event.clientY + 'px'
        const pointer = document.getElementById('mouse-pointer')
        if (pointer) {
          pointer.style.left = mouseX
          pointer.style.top = mouseY
        }
      }

      // Mouse enter/leave handlers
      const handleMouseEnter = (style) => {
        this.pointerStyle = style
      }

      const handleMouseLeave = () => {
        this.pointerStyle = ''
      }

      // Add event listeners
      document.addEventListener('mousemove', handleMouseMove)

      // Store handlers for cleanup
      this.mouseMoveHandler = handleMouseMove
      this.mouseEnterHandler = handleMouseEnter
      this.mouseLeaveHandler = handleMouseLeave

      // Wait for jQuery to be available
      this.$nextTick(() => {
        if (window.$ && window.jQuery) {
          // jQuery event handlers (matching the original script.js)
          window.$('.funfact-eight, .subscribe-one.home-16, .clients-one.home-7')
            .on('mouseenter', function () {
              handleMouseEnter('black')
            })
            .on('mouseleave', function () {
              handleMouseLeave()
            })

          window.$('.pointer-large, .owl-prev, .owl-next, a.theme-btn')
            .on('mouseenter', function () {
              handleMouseEnter('large')
            })
            .on('mouseleave', function () {
              handleMouseLeave()
            })

          window.$('a')
            .on('mouseenter', function () {
              handleMouseEnter('transparent')
            })
            .on('mouseleave', function () {
              handleMouseLeave()
            })

          window.$('.pointer-right, .banner-carousel, .two-item-carousel, .portfolio-carousel')
            .on('mouseenter', function () {
              handleMouseEnter('right')
            })
            .on('mouseleave', function () {
              handleMouseLeave()
            })
        }
      })
    },
    cleanup() {
      // Remove event listeners
      if (this.mouseMoveHandler) {
        document.removeEventListener('mousemove', this.mouseMoveHandler)
      }

      // Remove jQuery event handlers if jQuery is available
      if (window.$ && window.jQuery) {
        window.$('.funfact-eight, .subscribe-one.home-16, .clients-one.home-7')
          .off('mouseenter mouseleave')
        
        window.$('.pointer-large, .owl-prev, .owl-next, a.theme-btn')
          .off('mouseenter mouseleave')
        
        window.$('a')
          .off('mouseenter mouseleave')
        
        window.$('.pointer-right, .banner-carousel, .two-item-carousel, .portfolio-carousel')
          .off('mouseenter mouseleave')
      }
    }
  }
}
</script>

<style scoped>
/* The mouse pointer styles are already defined in the global CSS file */
/* This component uses the existing .mouse-pointer classes */
</style>
